import ReactGA from "react-ga4";
import {
  hasCookieYesConsentFor,
  watchCookieYesConsent,
} from "./cookieYesConsent";

const GA_TRACKING_ID = "G-03G6LWKP1C";

let analyticsStarted = false;
let stopConsentWatcher;

export const initializeAnalytics = () => {
  if (analyticsStarted) {
    return;
  }

  analyticsStarted = true;

  ReactGA.initialize([
    {
      trackingId: GA_TRACKING_ID,
    },
  ]);

  ReactGA.send({
    hitType: "pageview",
    page: window.location.pathname,
  });
};

export const startAnalyticsWhenConsented = () => {
  if (analyticsStarted) {
    return;
  }

  if (hasCookieYesConsentFor("analytics")) {
    initializeAnalytics();
    return;
  }

  stopConsentWatcher = watchCookieYesConsent(() => {
    initializeAnalytics();
    stopConsentWatcher?.();
    stopConsentWatcher = undefined;
  });
};
